module.exports = __webpack_public_path__ + "static/media/color-palette-block.5222878c.svg";